import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.svg',
    styleUrls: ['./profile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent {}
